import React from 'react';
import {
  DataGridButton,
  IColumnType,
  IDataType,
  SisDataGridColumns,
} from '../../../components/table';

export const Columns = (
  data,
  handleEdit,
  isReadOnly,
  translate,
  createTaskFromAssetCycle,
  history,
  assetId,
  canCreateTask,
): SisDataGridColumns => [
  {
    dataField: 'customId',
    caption: 'Revision cycle id',
    width: '7%',
    allowEditing: false,
  },
  {
    dataField: 'name',
    caption: 'Name',
    width: '11%',
    dataType: IDataType.string,
  },
  {
    dataField: 'capacityCategoryId',
    caption: 'Capacity category',
    width: '7%',
    allowEditing: true,
    cellRender: (data) => data.row.data.capacityCategoryName,
    requiredRule: true,
  },
  {
    dataField: 'revisionCategoryId',
    caption: 'Revision category',
    width: '7%',
    cellRender: (data) => data.row.data.revisionCategoryName,
    requiredRule: true,
  },
  {
    dataField: 'revisionStandard',
    caption: 'Revision standard',
    width: '12%',
  },
  {
    dataField: 'description',
    caption: 'Description',
    width: '19%',
  },
  {
    dataField: 'documentTypeNameTranslated',
    caption: 'Document type',
    width: '10%',
    dataType: IDataType.string,
  },
  {
    dataField: 'responsiblePersonName',
    caption: 'Responsible person',
    width: '10%',
    dataType: IDataType.string,
  },
  {
    dataType: IDataType.boolean,
    dataField: 'visible',
    caption: 'Visible',
    width: '7%',
  },
  {
    caption: 'Task from cycle',
    type: IColumnType.buttons,
    cellRender: (data) => {
      if (data.data.visible && canCreateTask)
        return CreateTaskCell(data, translate, createTaskFromAssetCycle, history, assetId);
      return <></>;
    },
    width: '10%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, isReadOnly, translate),
    width: '8%',
  },
];

const CreateTaskCell = (cellData, translate, createTaskFromAssetCycle, history, assetId) => {
  const handleRedirect = () => {
    history.push({
      pathname: `/tasks/edit/${cellData.data.lastTaskId}`,
      state: { backRoute: `/assets/edit/${assetId}` },
    });
  };

  return (
    <>
      {cellData.data.lastTaskId === null ? (
        <DataGridButton
          text={translate!('Create task from cycle', 'Asset.Cycle')}
          hint={translate!('Create task from cycle', 'Asset.Cycle')}
          stylingMode="contained"
          cellData={cellData}
          onClick={() => createTaskFromAssetCycle(cellData.data.id)}
        />
      ) : (
        <a onClick={handleRedirect} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
          {cellData.data.lastTaskCustomId}
        </a>
      )}
    </>
  );
};

const ButtonCell = (cellData, handleEdit, readOnly, translate) => {
  return (
    !readOnly && (
      <DataGridButton
        hint={translate!('Edit', '')}
        icon="edit"
        cellData={cellData}
        onClick={() => handleEdit(cellData)}
      />
    )
  );
};
